module.exports = __webpack_public_path__ + "static/media/handbags_video.afcb88c3.jpg";